// extracted by mini-css-extract-plugin
export var label = "_4r-1";
export var reminder = "_4r-0";